import config from "config";
import API from "./http";

const fleetVehicles = {
  async all(limit = 50, page = 1, registrationPlate = null) {
    try {
      const params = {
        limit,
        page
      };

      if (registrationPlate) {
        params.registrationPlate = registrationPlate;
      }

      const res = await API.get(`${config.CORP_API_URL}/fleet-vehicles`, {
        params
      });

      return res.data;
    } catch (err) {
      console.error("Error getting all vehicles", err);
      throw err;
    }
  },
  async get(id) {
    try {
      const res = await API.get(`${config.CORP_API_URL}/fleet-vehicle/${id}`);
      return res.data;
    } catch (err) {
      console.error(`Error getting vehicle ${id}`, err);
      throw err;
    }
  },
  async update(id, data) {
    try {
      const res = await API.put(`${config.CORP_API_URL}/fleet-vehicle/${id}`, data);
      return res.data;
    } catch (err) {
      console.error(`Error updating vehicle ${id}`, err);
      throw err;
    }
  },
  async create(data) {
    try {
      const res = await API.post(`${config.CORP_API_URL}/fleet-vehicles`, data);
      return res.data;
    } catch (err) {
      console.error("Error creating a vehicle", err);
      throw err;
    }
  },
  async bulkCreate(data) {
    try {
      const res = await API.post(`${config.CORP_API_URL}/fleet-vehicles/bulk-import`, data);
      return res.data;
    } catch (err) {
      console.error("Error sending a vehicle bulk import", err);
      throw err;
    }
  },
  async delete(id) {
    try {
      const res = await API.delete(`${config.CORP_API_URL}/fleet-vehicle/${id}`);
      return res.data;
    } catch (err) {
      console.error(`Error deleting vehicle ${id}`, err);
      throw err;
    }
  }
};

export default fleetVehicles;
